import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/movimentacao/implantacao' };
/////////////////////////////////////////////////////////////////////////////////

export function createImplantacaoAnimal(payload) {
  return httpService.post(args, payload);
}

export function updateImplantacaoAnimal(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listImplantacaoAnimal(param) {
  return httpService.get({ ...args, args: param });
}

export function findImplantacaoAnimal(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllImplantacaoAnimal() {
  return httpService.get({ ...args, path: '/pecuaria/movimentacao/implantacao/all' });
}

export function deleteImplantacaoAnimal(id) {
  return httpService.del({ ...args, args: `/${id}` });
}